import { gql } from "apollo-boost"

export const GET_PRODUCTS = gql`
  query Products($take: Int, $skip: Int, $input: ProductQueryInput) {
    products(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        url
        note
        name
        price
        photoUrl
        productNumber
        description
        isEnable
        category {
          id
          name
          isEnable
        }
        subcategory {
          id
          name
          isEnable
        }
      }
    }
  }
`
export const SUM_PRODUCTS = gql`
  query Products($input: ProductQueryInput) {
    products(take: 0, input: $input) {
      total
    }
  }
`

export const GET_COMPANIES = gql`
  query Companies {
    companies(take: 0) {
      total
      data {
        id
        name
        area
      }
    }
  }
`

export const GET_CATEGORIES = gql`
  query Categories {
    categories(take: 0) {
      total
      data {
        id
        name
        isEnable
        subcategories {
          id
          name
          isEnable
        }
      }
    }
  }
`

export const GET_PRODUCT = gql`
  query Product($id: ID!) {
    product(id: $id) {
      id
      url
      name
      note
      photoUrl
      productNumber
      description
      isEnable
      category {
        id
        isEnable
      }
      subcategory {
        id
        isEnable
      }
    }
  }
`

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($id: ID!, $input: ProductUpdateInput!) {
    updateProduct(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_PRODUCT = gql`
  mutation CreateProduct($input: ProductCreateInput!) {
    createProduct(input: $input) {
      id
    }
  }
`

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`

export const GET_SHOPPING_CART = gql`
  query ShoppingCart($companyId: ID) {
    shoppingCart(companyId: $companyId) {
      id
    }
  }
`

export const UPDATE_SHOPPING_CART = gql`
  mutation UpdateShoppingCart(
    $orderId: ID!
    $orderDetailInputs: [UpdateShoppingCartInput]
  ) {
    updateShoppingCart(
      orderId: $orderId
      orderDetailInputs: $orderDetailInputs
    ) {
      id
      order {
        orderDetails {
          id
          unitPrice
        }
      }
    }
  }
`

export const ADD_PRODUCT_TO_SHOPPING_CART = gql`
  mutation AddProductToShoppingCart($input: AddProductToShoppingCartInput!) {
    addProductToShoppingCart(input: $input) {
      id
      orderDetailNumber
    }
  }
`
